import React,{useState,useContext} from 'react';
import Modal from '../Settings/Modal';
import { SettingModal, useSettingModal } from '../../../hooks/Context';
import styled from '@emotion/styled';
import { TopDisplay,Button,UploadButton } from '../../../ui-components';
import { BatchInvites } from './Modal';
import apiCall from '../../../utils/apiCall';
import fileDownload from 'js-file-download';
import { NotificationContext } from '../../../providers/notification';
import DisplayInductionInvites from './DisplayInductionsInvites';
import apiCallFormData from '../../../utils/apiFormDataCall';
import BatchIdGen from './Modal/BatchIdGen';
import { useMutation, useQuery } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { ExNyRoute } from '../../../utils/allRouteId';




export default function InductionInvites() {

  const [route, setRoute] = useState<{name: string, val: number}>({name: 'Examination / NYSC', val: Number(ExNyRoute)})
  
  return (

      <SettingModal>
        <ViewWrapper>
              <TopDisplay subTitle={` All Pending / Awaiting Invites` } title="Induction-Invites" Btn={<TopBtns id={route?.val}/>} />
              <DisplayInductionInvites route= {route} setRoute = {setRoute}/>
        </ViewWrapper>
        <Modal />
      </SettingModal>
   
    
  )
}

export const TopBtns = (props:any)=>{
  const {setModalContent,setShowModal} = useSettingModal();
  const {showNotification} = useContext(NotificationContext);
  const [d_loading,set_d_loading] = useState<boolean>(false);
  const [u_loading,set_u_loading] = useState<boolean>(false);
  
  const handleInviteBatch = () => {
    setModalContent(<BatchInvites />)
    setShowModal(true);
  }

  const handleGenerateMembershipId = () => {
    setModalContent(<BatchIdGen />)
    setShowModal(true);
  }

  const routeId = props.id || 1;

  const downloadApplicantPendingInduction = async () => {
    return await (apiCall().get(`/Activity/DownloadPendingInduction?routeId=${routeId}&activity=Induction`, {responseType: 'blob'}))
  };

  const { data, isSuccess, error, refetch, isLoading, isFetching } = useQuery(['download-applicant-pending-induction', routeId], downloadApplicantPendingInduction, {
    retry: 0,
    keepPreviousData: true,
    enabled: false
  });

  const downloadApplicantPendingInductionError = error as AxiosError;
  const downloadApplicantPendingInductionErrorMessage = downloadApplicantPendingInductionError?.message;

  const handleDownloadApplicantPendingInduction = async () => {

    await refetch().then((data: any) => {
      if(!data) return
    
      const blob = new Blob([data?.data?.data], {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      const isSuccess = true;
    
      if (isSuccess) {
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'Inductionlist.xlsx');
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
    } else {
      showNotification({
        type: 'error',
        message: 'No record found for download',
      })
    }
    })
    };

  const uploadInductionAttendee = async (data: FormData) => {
    return await (apiCallFormData().post('/Activity/UploadInductionAttendant', data))
  };

  const uploadInductionAttendeeMutation = useMutation(['upload-induction-attendee'], uploadInductionAttendee, {retry: 0});

  const handleUpload = async (e:any) => {
    let file = e.target.files[0];
    let activity = "Induction";

    const body = new FormData();
    body.append('RouteId', routeId);
    body.append('Activity', activity);
    body.append('Inductee', file);

    set_u_loading(true);
    try {
      await uploadInductionAttendeeMutation.mutateAsync(body, {
        onSuccess: (data) => {
          showNotification({
            message: 'file uploaded successfully',
            type:'success'
          })
          set_u_loading(false);
        }
      })
    }catch(error: any) {
      showNotification({
        message: error?.response?.data?.Message || error?.message || 'file not uploaded ',
        type:'error'
      })
    }
    e.target.value = ''
  }

  return (<div style={{display:'flex',gap:'10px'}}>
    {/* <UploadButton onChange={handleUpload} label={u_loading ? "Uploading..." : "Upload Induction List"}/>
    <Button onClick={handleDownloadApplicantPendingInduction} children={isFetching ? "Downloading..." : "Download"} border="#E2E4E9" bg="#E2E4E9" color="#11643C;" /> */}
    <Button onClick={handleInviteBatch} children={'Batch Invite'}  />
    <Button onClick={handleGenerateMembershipId} children={'Generate Membership '}  />

  </div>)
}

export const ViewWrapper = styled.div`
  width: 100%;
  padding:0 48px 48px;
`

